<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pA0S"><a href="#/contents#RR_18" id="CC_18"> Myers Lake</a></p>
<p class="tx6" id="pA4qz"><i> It’s the spot. </i></p>
<p class="tx5" id="pAMDc"><b> ½ cup sugar </b></p>
<p class="tx5" id="pA8i"><b> 2 cups water </b></p>
<p class="tx5" id="pAKF1"><b> ½ teaspoon cinnamon </b></p>
<p class="tx5" id="pALX"><b> 2 to 3 cups orange juice, no pulp </b></p>
<p class="tx5" id="pAag8"><b> 1 cup pineapple juice </b></p>
<p class="tx5" id="pA87"><b> 6 cups apple juice or cider </b></p>
<p class="tx1" id="pA8eo"><span class="dcap">B</span>oil water and sugar together until sugar melts, stirring often. Mix cinnamon in well; add juices. Refrigerate overnight or several hours to meld flavors. Decorate punch bowl with cinnamon sticks, orange and/or lemon slices studded with whole cloves, and frozen cider ice molds.</p>
<p class="tx" id="pAn8W"> Makes 25 punch cups.</p>
<p class="txrr" id="pAU-K"> <i>Janine Johnson—Orlando, Florida</i></p>
<div class="image" id="pAS9">
<p class="ser"><img alt="images/img-20-1.jpg" id="AS9" src="images/img-20-1.jpg"/></p>
<p class="txcc" id="pAkR"> <i>“Now, take down your fishin’ pole and meet me at the fishin’ hole.”</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter18.vue?56e556e6